module.exports = __webpack_public_path__ + "static/media/previous_arrow.d521892b.svg";